import { Typography } from "@mui/material";
import RecievedVoiceMessage from './recievedVoiceMessage'
import FileMessage from './FileMessage'

export default function Message(props) {
  const { message } = props

  if (message?.file?.mime_type === 'audio/mpeg') return <RecievedVoiceMessage message={message}/>

  if (message?.file?.mime_type === "image/jpeg") {
    return <FileMessage message={message}/>
  }

  return (
    <Typography>
      {message.message}
    </Typography>
  );
}
